import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { SummaryTypeComponent } from './summary-type.component';
import { MatFormFieldModule } from '@angular/material/form-field';

@NgModule({
  declarations: [SummaryTypeComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'summary',
          component: SummaryTypeComponent,
          defaultOptions: {
            className: 'mt-0',
          },
        },
      ],
    }),
  ],
})
export class SummaryTypeModule {}
